import {businessInterface} from "../interfaces/businessInterface";
import { 
    actionSetAuth,
    actionSetLogout
} from '../actions/businessAction';
import { 
    getStore,
    setStore,
    deleteStore
} from '../storage';

const initBusiness : businessInterface = {
    id: null,
    name: '',
    email: '',
    country: '',
    typeBusiness: '',
    apiKey: '',
    apiSecret: '',
    role: ''
}

let initialState = getStore() || initBusiness ;

type Actions = ReturnType<typeof actionSetAuth | typeof actionSetLogout>;

export const businessReducer = (state : businessInterface = initialState, action : Actions) => {
    switch (action.type) {
        case 'AUTH':
            setStore(action.payload);
            return  action.payload;
        case 'LOGOUT':
            deleteStore();
			return initBusiness;
        default:
            return state;
    }
};

export default businessReducer;